// extracted by mini-css-extract-plugin
export default {"editor-panel-container":"styles_editor-panel-container__SHxSL","editor-panel-content":"styles_editor-panel-content__sIKm5"};